import "core-js/stable";
import "regenerator-runtime/runtime.js";
import cssVars from 'css-vars-ponyfill';

import "normalize.css";
import App from "./App.svelte";
import "../../ui/src/reset.scss"
import "@hitit/new_ui/src/style.scss"
cssVars();

const app = new App({
	target: document.body,
});

export default app;
